import React, { useEffect, useState } from 'react'
import ReportsAndStatisticsView from '../../views/reports-and-statistics/reports-and-statistics.view'
import { useHistory, useLocation } from 'react-router-dom';
import { ClientsService, LocalStorageService } from '../../../services';
import moment from 'moment';
import { ModalUtil } from '../../pures';
import { useTranslation } from 'react-i18next';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
let token = localStorageService.getLocalStorageItem("token")
if (token) token = token.idToken
const clientsService = new ClientsService(url)

const estimatePeriod = (startDate, endDate) => {
    startDate = moment(startDate)
    endDate = moment(endDate)

    // if the dates are the same
    if (startDate.isSame(endDate, 'day')) return "day"
    // if the difference is between 7 or less days
    if (endDate.diff(startDate, 'day') <= 7) return "week"
    // if the dates are within the same month
    if (startDate.isSame(endDate, 'month')) return "month"
    // if the dates are in different months, the period is "year"
    return "year"
}

function ReportsAndStatisticsAction() {
    const history = useHistory();
    const location = useLocation();

    const { t } = useTranslation();
    const modalUtil = new ModalUtil()

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState({})

    const [dates, setDates] = useState({
        startDate: moment().subtract(1, 'year').toDate(),
        endDate: moment().toDate()
    })
    const [periodType, setPeriodType] = useState("year") // "year" | "month" | "week" | "day"

    const handleChangeDate = (event, field) => {
        setDates({ ...dates, [field]: event.target.value });
    }

    const loadData = async (firstRender) => {
        setIsLoading(true)

        try {
            let startDate = dates.startDate
            let endDate = dates.endDate

            if (firstRender) {
                if (location.search) {
                    const searchParams = new URLSearchParams(location.search);
                    startDate = moment(searchParams.get('startDate')).toDate()
                    endDate = moment(searchParams.get('endDate')).toDate()
                    setDates({ startDate, endDate })
                }
            } else {
                const searchParams = new URLSearchParams();
                startDate = moment(dates.startDate).toDate()
                endDate = moment(dates.endDate).toDate()

                searchParams.append('startDate', moment(startDate).format('YYYY-MM-DD'));
                searchParams.append('endDate', moment(endDate).format('YYYY-MM-DD'));
                history.replace({ pathname: '/reports', search: searchParams.toString() })
            }

            const period = estimatePeriod(startDate, endDate)
            const dashboardData = await clientsService.getReportsAndStatisticsDashboard(token, startDate, endDate, period)
            setPeriodType(period)
            setData(dashboardData)
            setIsLoading(false)
        } catch (error) {
            modalUtil.showModal('error', "Error cargando", error.message || t("modal.pure.title.error"))
        }
    }

    useEffect(() => {
        loadData(true);
    }, [])

    return (
        <ReportsAndStatisticsView
            isLoading={isLoading}
            dates={dates}
            handleChangeDate={handleChangeDate}
            handleSearch={() => loadData(false)}
            periodType={periodType}
            data={data}
        />
    )
}

export default ReportsAndStatisticsAction